import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { c as currentCancellationPeriodOrFirst, b as formatPeriod } from "./helpers-_43eq5lm.js";
import { f, a, t } from "./helpers-_43eq5lm.js";
import { jsx } from "react/jsx-runtime";
import { Tag } from "@silversea-ssc/ui-components-react";
import { Trans } from "@lingui/react";
import { match } from "ts-pattern";
const tagMarginFixed = "cancellation-policy-infographic-step-module_tag-margin-fixed__eHlog";
const styles = {
  tagMarginFixed
};
const toCancellationPolicyInfographicStep = (t2, languageCode, paymentTerms) => {
  if (!paymentTerms) return void 0;
  const period = currentCancellationPeriodOrFirst(paymentTerms);
  const cancellationAdminFee = paymentTerms.cancellationAdminFee;
  if (!period) return void 0;
  const penaltyInfo = formatPeriod(t2, languageCode, period, paymentTerms.currency, cancellationAdminFee, false);
  const tagProps = match(penaltyInfo.color).with("green", () => ({
    variant: "success",
    children: /* @__PURE__ */jsx(Trans, _objectSpread({}, /*i18n*/
    {
      id: "6815iA",
      message: "Flexible"
    }))
  })).with("yellow03", () => ({
    variant: "warning",
    children: /* @__PURE__ */jsx(Trans, _objectSpread({}, /*i18n*/
    {
      id: "dvYuhh",
      message: "Moderate"
    }))
  })).with("red", () => ({
    variant: "negative",
    children: /* @__PURE__ */jsx(Trans, _objectSpread({}, /*i18n*/
    {
      id: "bD/+Ei",
      message: "Strict"
    }))
  })).exhaustive();
  return {
    description: penaltyInfo.label,
    tag: /* @__PURE__ */jsx(Tag, _objectSpread({
      className: styles.tagMarginFixed
    }, tagProps))
  };
};
export { currentCancellationPeriodOrFirst, f as firstPeriodIsTypeDeposit, formatPeriod, a as formattedAdministrativeFeeDisclaimer, toCancellationPolicyInfographicStep, t as toPenaltiesInfographicStep };